import React, { Fragment } from 'react';
import API from '../../../../utils/API';
import InputField from '../../../../components/inputs/inputField';
import FieldModal from '../../../../components/modals/fieldModal';
class RenamePageModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			title: this.props.page.title ? this.props.page.title : '',
			submitting: false,
			requiredFields: { title: false }
		};
      
	}

	handleNameChange = (p) => {
		this.setState({
			title: p.target.value
            
		});
        console.log("title", )
	};

	updateTitle = async () => {
		this.setState({ submitting: true });
		const { title, } = this.state;
		const { eventId, orgId, page, update, toggle, } = this.props;
		const requiredFields = this.state.requiredFields;
		let valid = true;
		if (!title) {
			requiredFields.title = true;
			valid = false;
		}
        
		if (valid) {
			await API()
				.patch(`Organizations/${orgId}/events/${eventId}/pages/${page._id}`, {

					title: title
				})
				.then((res) => {
					if (res.data) {
						update(
							{
								title: title,
								lastEditedBy: res.data.lastEditedBy,

							},
							() => {
								toggle();
							}
						);
					}
				});
		} else {
			this.setState({ submitting: false, requiredFields: requiredFields });
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { submitting, title, requiredFields } = this.state;
		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Rename Page"}
					bodyHeaderText={'Enter a new title for your Page.'}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div>
								<InputField
									label="title"                                 
									value={title}                                    
									required={true}                                 
									errorTrigger={requiredFields.title}
									onChange={this.handleNameChange}
								/>
							</div>)
                            
					}}
                    
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Save' : 'Saving...'}
					actionButton={() => this.updateTitle()}
					actionButtonDisabled={submitting}
				></FieldModal>
			</div>

		);
	}
}

export default RenamePageModal;
